export class PendingInfluencer {
  id: number;
  name: string;
  description: string;
  domain: string;
  is_active: number;
  country: number;
  countryPriority?: PendingInfluencerCountryPriority;
  countryPriorityUserName?: string;
  phone: string;
  email: string;
  languages: number;
  gender: number;
  dismiss_reason: string;
  network: string;
  pending_completed: boolean;
  system_email: string;
  channels: PendingInfluencerChannel[];
  new_channels?: number[];
}

export class PendingInfluencerChannel {
  id: number;
  handle: string;
  type: number;
  source_id: number;
  platform_id: number;
  source_id_error: string;
  status: PendingInfluencerChannelStatus;
  index?: number;
  handle_error?: string;
  handle_updated?: boolean;
  platformName?: string;
  link?: string;
}

export enum PendingInfluencerChannelStatus {
  NEW = 1,
  ADDED = 2
}

export enum PendingInfluencerCountryPriority {
  SET_MANUALLY = 1,
  SET_BY_USER = 2,
  SET_BY_ADMIN= 3,
  SET_BY_ANALYST= 4,
  DISCOVERED_VIA_FLAG = 5,
  DISCOVERED_VIA_POST_GEO_TAGS = 6,
  DISCOVERED_VIA_POST_PHONE_NO = 7
}




// WEBPACK FOOTER //
// ./src/models/influencer/pending-influencer.ts